import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Layout/Header/Header';
import Footer from './components/Layout/Footer/Footer';
import AuthGuard from './components/Guards/GuardAuth';
import Home from './components/Sections/Home/Home';
import CreateForm from './components/Sections/CreateForm/CreateForm';
import GetForms from './components/Sections/GetForm/GetForms';
import CreateUser from './components/Sections/createUser/createUser';

const Router = () => (
    <BrowserRouter>
        <Header />
        <Routes>
            <Route
                path="/"
                element={
                    <AuthGuard>
                        <Home />
                    </AuthGuard>
                }
            />
            <Route
                path="/create-form"
                element={
                    <AuthGuard>
                        <CreateForm />
                    </AuthGuard>
                }
            />
            <Route
                path="/forms"
                element={
                    <AuthGuard>
                        <GetForms />
                    </AuthGuard>
                }
            />
            <Route
                path="/create-user"
                element={
                    <AuthGuard>
                        <CreateUser />
                    </AuthGuard>
                }
            />
        </Routes>

        <Footer />
    </BrowserRouter>
);

export default Router;
